import { createFileRoute } from "@tanstack/react-router";

import Solutions from "../pages/Solutions";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/solutions/")({
  component: SolutionsRoute,
});

function SolutionsRoute() {
  return (
    <RequireAuth require="adminOrLimitedAdmin">
      <Solutions />
    </RequireAuth>
  );
}
